export const SiteTabs = [
  {
    color: "var(--white)",
    route: "",
    name: { english: "about", chinese: "大约" },
    first: true,
    delay: { desktop: "1500ms", mobile: "200ms" },
    rotation: "315deg",
    scaleOrigin: "top left",
  },
  {
    color: "var(--blue)",
    route: "food",
    name: { english: "food", chinese: "餐饮" },
    first: false,
    delay: { desktop: "1250ms", mobile: "300ms" },
    rotation: "45deg",
    scaleOrigin: "top right",
  },
  {
    color: "var(--red)",
    route: "retail",
    name: { english: "retail", chinese: "購物" },
    first: false,
    delay: { desktop: "1000ms", mobile: "400ms" },
    rotation: "45deg",
    scaleOrigin: "bottom left",
  },
  {
    color: "var(--orange)",
    route: "community",
    name: { english: "community", chinese: "文化" },
    first: false,
    delay: { desktop: "750ms", mobile: "500ms" },
    rotation: "315deg",
    scaleOrigin: "bottom right",
  },
];

export const HomeEvents = [
  {
    id: "1",
    date: "10/22",
    description: "Small Business Retail Pop Up Weekend!",
  },
  {
    id: "2",
    date: "02/07",
    description:
      "New Balance x Paperboy Paris by Greenhouse @ Canal Street Market",
  },
  { id: "3", date: "12/11", description: "Hack City 12/11" },
];

export const FoodVendors = [
  {
    id: "1",
    primaryText: "Betong",
    subText: "Khao Man Gai",
    previewImgPath: "/assets/food/food_1.png",
  },
  {
    id: "2",
    primaryText: "Chinatown Deli",
    subText: "Coffee, Pastries & Smoothies",
    previewImgPath: "/assets/food/food_2.png",
  },
  {
    id: "3",
    primaryText: "Daniel Corpuz Chocolatier",
    subText: "Artisanal Chocolates",
    previewImgPath: "/assets/food/food_3.png",
  },
  {
    id: "4",
    primaryText: "Enzo Bruni La Pizza Gourmet",
    subText: "Napoli Style Pizza",
    previewImgPath: "",
  },
  {
    id: "5",
    primaryText: "Joe's Rice and Noodles",
    subText: "Chinese Classics",
    previewImgPath: "",
  },
  {
    id: "6",
    primaryText: "Joe's Steam Rice Roll",
    subText: "Cantonese Steamed Rice Rolls",
    previewImgPath: "/assets/food/food_4.png",
  },
  {
    id: "7",
    primaryText: "Kabisera",
    subText: "Delicious Filipino Classics",
    previewImgPath: "",
  },
  {
    id: "8",
    primaryText: "Lazy Sundaes",
    subText: "Bingsoo Sundaes & Bubble Tea",
    previewImgPath: "/assets/food/food_5.png",
  },
  {
    id: "9",
    primaryText: "Mastunori",
    subText: "Sushi, Handrolls & Chirashi",
    previewImgPath: "/assets/food/food_6.png",
  },
  {
    id: "10",
    primaryText: "Mucho Sarap",
    subText: "COMING SOON",
    previewImgPath: "",
  },
];

export const Retailers = [
  {
    id: "1",
    primaryText: "American Design Club",
    subText: "Design Objects",
    previewImgPath: "/assets/retail/retail_1.jpg",
  },
  {
    id: "2",
    primaryText: "Beeshaus & Raum NYC",
    subText: "Jewelry",
    previewImgPath: "/assets/retail/retail_2.jpg",
  },
  {
    id: "3",
    primaryText: "Beroep Tech",
    subText: "Jewelry",
    previewImgPath: "/assets/retail/retail_3.jpg",
  },
  {
    id: "4",
    primaryText: "Dandy Farmer Bonsai Shop",
    subText: "Bonsai Shop",
    previewImgPath: "/assets/retail/retail_4.jpg",
  },
  {
    id: "5",
    primaryText: "Friend Of A Friend Studio",
    subText: "Fashion Apparel",
    previewImgPath: "/assets/retail/retail_5.jpg",
  },
  {
    id: "6",
    primaryText: "Leibal",
    subText: "Design Objects",
    previewImgPath: "/assets/retail/retail_6.jpg",
  },
  {
    id: "7",
    primaryText: "Mandu Apparel",
    subText: "K Pop Apparel and Merchandise",
    previewImgPath: "/assets/retail/retail_7.jpg",
  },
  {
    id: "8",
    primaryText: "Mogutable",
    subText: "Home Goods",
    previewImgPath: "/assets/retail/retail_8.jpg",
  },
  {
    id: "9",
    primaryText: "Office Magazine Newstand",
    subText: "Newstand and Magazines",
    previewImgPath: "/assets/retail/retail_9.jpg",
  },
  {
    id: "10",
    primaryText: "Preppy Trendy",
    subText: "Fashion Apparel",
    previewImgPath: "/assets/retail/retail_10.jpg",
  },
  {
    id: "11",
    primaryText: "Savage Anchor",
    subText: "Sunglasses",
    previewImgPath: "/assets/retail/retail_11.png",
  },
  {
    id: "12",
    primaryText: "Seven 50",
    subText: "Jewelry",
    previewImgPath: "/assets/retail/retail_12.jpg",
  },
  {
    id: "13",
    primaryText: "Siizu",
    subText: "Sustainable lifestyle store",
    previewImgPath: "/assets/retail/retail_13.jpg",
  },
  {
    id: "14",
    primaryText: "Swagychic",
    subText: "Jewelry",
    previewImgPath: "/assets/retail/retail_14.jpeg",
  },
  {
    id: "15",
    primaryText: "Tissi",
    subText: "Jewelry",
    previewImgPath: "/assets/retail/retail_15.png",
  },
];

export const Community = [];

export const CommunityPodcasts = [
  {
    id: "1",
    date: "10/28",
    description:
      "2022 NWSL Finals Preview + Ballon d'Or Recap + Review of ESPN Truth Be Told Documentary",
  },
  {
    id: "2",
    date: "10/23",
    description: "S2E25: Pretty Big Deal Asians with Jenny Arimoto",
  },
  { id: "3", date: "05/03", description: "We're back and we're better!" },
];
